import React, { useState, useRef } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '驗證碼',
    placeholder: '請輸入驗證碼',
    alert: '請填寫您的手機或信箱',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(3)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }
  const cannotOpenQuestionSetN = `{q34} anyof [0, 1, 2, 3, 4, 5, 6, 7 ,8, 9, 10, 11, 12, 'other']`

  const visibleIfConditionsInit = {
    q4: '{q3} anyof [0, 1, 2, 3, 4, 5]',
    q18: '{q17} = 0',
    q19: '{q17} = 1',
    q22: '{q21} = 0 or {q21} = 2',
    q23: '{q21} = 1 or {q21} = 2',
    q24: '{q22} anyof [1] or {q23} anyof [1]',
    q25: '{q24} anyof [0, 1, 2]',
    q26: '{q24} anyof [3, 4]',
    q28: '{q27} = 0',
    q30: '{q29} anyof [2]',
    q31: `{q29} anyof [0, 1, 2, 3, 4, 5, 6, 7 ,8, 9, 10, 11, 12, 'other']`,
    q33: '{q32} anyof [3]',
    // 題組 N
    q35: cannotOpenQuestionSetN,
    q36: cannotOpenQuestionSetN,
    q37: cannotOpenQuestionSetN + ' and {q36} = 0 or {q36} = 2',
    q38: cannotOpenQuestionSetN + ' and {q36} = 1 or {q36} = 2',
    q39: cannotOpenQuestionSetN + ' and {q36} = 1 or {q36} = 2',
    q40: cannotOpenQuestionSetN + ' and {q39} = 0',
    q41: cannotOpenQuestionSetN + ' and {q39} = 0',
    q42: cannotOpenQuestionSetN + ' and {q41} = 2',
    q43: cannotOpenQuestionSetN,
    q44:
      cannotOpenQuestionSetN +
      ` and {q43} anyof [0, 1, 2, 3, 4, 5, 6, 7 ,8, 9, 10, 11, 12, 13, 14, 'other']`,
    q45: cannotOpenQuestionSetN,
    q46: cannotOpenQuestionSetN + ' and {q45} = 0',
    q47:
      cannotOpenQuestionSetN +
      ` and {q45} = 0 and {q46} anyof [0, 1, 2, 3, 4, 5, 6, 'other']`,
    q48:
      cannotOpenQuestionSetN +
      ` and {q45} = 0 and {q46} anyof [0, 1, 2, 3, 4, 5, 6, 'other']`,
    q49:
      cannotOpenQuestionSetN +
      ` and {q45} = 0 and {q46} anyof [0, 1, 2, 3, 4, 5, 6, 'other'] and {q48} = 0 or {q48} = 1 or {q48} = 2`,
    q51: '{q50} anyof [0, 1]',
    q52: '{q50} anyof [0, 1]',
    q54: '{q53} anyof [4]',
    q62: '{q61} = 2 or {q61} = 3 or {q61} = 4 or {q61} = 5',
    q63: '{q62} = 0',
    q64: '{q62} = 1',
    q66: '{q65} = 1',
    q67: '{q66} = 1',
    q69: '{q68} = 1',
    q70: '{q69} = 1',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    {
      type: 'complete',
      expression:
        '({q0} = 1 or {q0} = 2) or ({q1} = 0 or {q1} = 1 or {q1} = 8 or {q1} = 9) or ({q2} = 1 or {q2} = 2) or ({q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3)',
      //     expression: `{q3} <> 4 or ({q4} = 16 or {q4} = 20 or {q4} = 21)`,
    },
    {
      type: 'complete',
      expression: '{q6} notcontains 0',
    },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
  })

  const newSurvey = new Model(convertedSurvey)
  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])
  const endMessage = `很抱歉，目前與您相同特性的樣本已經額滿，沒辦法參與本次活動。歡迎您分享本問卷連結給其他親朋好友，或加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  // 帶入選項
  const questionMappings = {
    q29: 'q31',
  }

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q1)', survey.getValue('q1'))

    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
    if (questionMappings.hasOwnProperty(options.name)) {
      // 篩選變下一題的選項

      const targetQuestionName = questionMappings[options.name]
      const targetQuestion = survey.getQuestionByName(targetQuestionName)
      const sourceQuestion = survey.getQuestionByName(options.name)
      let choices = []

      if (options.value) {
        options.value.forEach(function (choiceValue, index) {
          if (typeof choiceValue === 'number') {
            const foundChoice = sourceQuestion.choices.find(
              (choice) => choice.value === choiceValue
            )

            const choiceText = foundChoice ? foundChoice.text : choiceValue
            choices.push({ value: index, text: choiceText })
          } else if (choiceValue === 'other') {
            choices.push({
              value: index,
              text: '其他(上題填寫內容)',
            })
          } else if (choiceValue === 'none') {
            choices.push({
              value: index,
              text: options.question.noneText,
            })
          }
        })
      }

      // targetQuestion.showOtherItem = sourceQuestion.isOtherSelected
      // targetQuestion.otherText = sourceQuestion.otherText

      // targetQuestion.showNoneItem = sourceQuestion.isNoneSelected
      // targetQuestion.noneText = sourceQuestion.noneText

      targetQuestion.choices = choices
      // if (targetQuestionName === 'q24' || targetQuestionName === 'q34') {
      //   targetQuestion.minSelectedChoices = choices.length
      // }

      // targetQuestion.defaultValue = []

      // 最後回傳的 order 要改
      const order = targetQuestion.visibleChoices
      if (order) {
        // 將選項順序設為每個選項的索引值
        choiceIndexMapRef.current[targetQuestionName] = order.reduce(
          (map, choice, index) => {
            map[index] = { index: index, title: choice.title }
            return map
          },
          {}
        )
        // console.log('choiceIndexMapRef', choiceIndexMapRef)
      }
    }
  }

  const endSurveyMsg = (survey) => {
    if (
      survey.getValue('q0') === 1 ||
      survey.getValue('q0') === 2 ||
      survey.getValue('q1') === 0 ||
      survey.getValue('q1') === 1 ||
      survey.getValue('q1') === 8 ||
      survey.getValue('q1') === 9 ||
      survey.getValue('q2') === 1 ||
      survey.getValue('q2') === 2 ||
      survey.getValue('q5') === 0 ||
      survey.getValue('q5') === 1 ||
      survey.getValue('q5') === 2 ||
      survey.getValue('q5') === 3
    ) {
      setCompletionMessage(endMessage)
    } else if (survey.getValue('q6') && !survey.getValue('q6').includes(0)) {
      setCompletionMessage(endMessage)
    } else {
      setCompletionMessage(
        `<h4 style='text-align: center'>問卷已成功送出</h4><h4 style='text-align: center'>請按「完成」前往下載 EZChoice 或填寫更多問卷</h4>`
      )
    }
  }

  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})

  useSubmitAnswers({
    survey: newSurvey,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
  })

  return (
    <>
      {convertedSurvey ? (
        <Survey model={newSurvey} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
